export default "__VITE_ASSET__92fa047f__"